import { useAtom } from "jotai";
import { useCallback } from "react";

import { showLoadingSpinnerAtom } from "../../../lander-quiz/lander-quiz.state";
import { FKCService } from "../../fkc.service";
import { pagesAtom } from "../../fkc.state";
import { Pages } from "../../fkc.types";
import { Fallback } from "../shared/fallback/fallback.component";

export function VerificationRetryPage(): JSX.Element {
  const [, setPage] = useAtom(pagesAtom);
  const [, setIsLoading] = useAtom(showLoadingSpinnerAtom);

  const resendVerificationCode = useCallback((): void => {
    setIsLoading(true);

    FKCService
      .resendVerificationCode(
        window.theme.Sweepstake.prototype.retrieveSubmission()?.data?.email
      )
      .finally(() => {
        setIsLoading(false);
        setPage(Pages.VERIFICATION);
      });
  }, [setPage, setIsLoading]);

  return (
    <Fallback
      title="Sorry we could not verify the account, try another code?"
      onTryAgain={resendVerificationCode}
    />
  )
}
